var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup163(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_75_2221)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_2221)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_75_2221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11.875C21.1603 11.875 22.2731 12.3359 23.0936 13.1564C23.9141 13.9769 24.375 15.0897 24.375 16.25C24.375 17.4103 23.9141 18.5231 23.0936 19.3436C22.2731 20.1641 21.1603 20.625 20 20.625C18.8397 20.625 17.7269 20.1641 16.9064 19.3436C16.0859 18.5231 15.625 17.4103 15.625 16.25C15.625 15.0897 16.0859 13.9769 16.9064 13.1564C17.7269 12.3359 18.8397 11.875 20 11.875ZM11.25 15C11.95 15 12.6 15.1875 13.1625 15.525C12.975 17.3125 13.5 19.0875 14.575 20.475C13.95 21.675 12.7 22.5 11.25 22.5C10.2554 22.5 9.30161 22.1049 8.59835 21.4017C7.89509 20.6984 7.5 19.7446 7.5 18.75C7.5 17.7554 7.89509 16.8016 8.59835 16.0983C9.30161 15.3951 10.2554 15 11.25 15ZM28.75 15C29.7446 15 30.6984 15.3951 31.4017 16.0983C32.1049 16.8016 32.5 17.7554 32.5 18.75C32.5 19.7446 32.1049 20.6984 31.4017 21.4017C30.6984 22.1049 29.7446 22.5 28.75 22.5C27.3 22.5 26.05 21.675 25.425 20.475C26.5148 19.068 27.0207 17.2952 26.8375 15.525C27.4 15.1875 28.05 15 28.75 15ZM11.875 27.8125C11.875 25.225 15.5125 23.125 20 23.125C24.4875 23.125 28.125 25.225 28.125 27.8125V30H11.875V27.8125ZM5 30V28.125C5 26.3875 7.3625 24.925 10.5625 24.5C9.825 25.35 9.375 26.525 9.375 27.8125V30H5ZM35 30H30.625V27.8125C30.625 26.525 30.175 25.35 29.4375 24.5C32.6375 24.925 35 26.3875 35 28.125V30Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_75_2221",
    x: 3,
    y: 11.875,
    width: 34,
    height: 22.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_75_2221"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_75_2221",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_2221",
    x1: 20,
    y1: -4.8,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003F6B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_2221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup163);
export default __webpack_public_path__ + "static/media/group163.f9299b8773adf917c2a994e87edd3147.svg";
export { ForwardRef as ReactComponent };